import { pageVariants } from 'animations/motionConfig';
import { useReducedMotion } from 'animations/useReducedMotion';
import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAdminCardEntrance } from './useAdminCardEntrance';

interface AnimatedPageOutletProps {
    children: ReactNode;
}

const AnimatedPageOutlet: FC<AnimatedPageOutletProps> = ({ children }) => {
    const location = useLocation();
    const reducedMotion = useReducedMotion();
    useAdminCardEntrance();

    if (reducedMotion) {
        return <div className="animated-page-outlet">{children}</div>;
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname}
                className="animated-page-outlet admin-page-3d"
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                style={{ perspective: 1200 }}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
};

export default AnimatedPageOutlet;
